import { ELEMENT_PARAGRAPH } from '@udecode/plate-paragraph';

import { ResetNodePlugin } from '@udecode/plate-reset-node';
import { SoftBreakPlugin, ExitBreakPlugin } from '@udecode/plate-break';

import { KEYS_HEADING } from '@udecode/plate-heading';

export const optionsResetBlockTypePlugin: ResetNodePlugin = {
  rules: [
    // {
    //   ...resetBlockTypesCommonRule,
    //   hotkey: 'Enter',
    //   predicate: isBlockAboveEmpty,
    // },
    // {
    //   ...resetBlockTypesCommonRule,
    //   hotkey: 'Backspace',
    //   predicate: isSelectionAtBlockStart,
    // },
  ],
};

export const optionsSoftBreakPlugin: SoftBreakPlugin = {
  rules: [
    // { hotkey: 'shift+enter' },
    // {
    //   hotkey: 'enter',
    //   query: {
    //     allow: [
    //       options[ELEMENT_CODE_BLOCK].type,
    //       options[ELEMENT_BLOCKQUOTE].type,
    //       options[ELEMENT_TD].type,
    //     ],
    //   },
    // },
  ],
};

export const optionsExitBreakPlugin: ExitBreakPlugin = {
  rules: [
    // {
    //   hotkey: 'mod+enter',
    // },
    // {
    //   hotkey: 'mod+shift+enter',
    //   before: true,
    // },
    {
      hotkey: 'enter',
      query: {
        start: true,
        end: true,
        allow: KEYS_HEADING,
      },
    },
  ],
};
